import { gql } from '@apollo/client'

const EDIT_INSURANCE_COMPANY = gql`
  mutation EDIT_INSURANCE_COMPANY(
    $insuranceCompany: ID!
    $name: String!
    $number: String
    $email: String
    $details: String
    $taxPercent: Float
    $insurancePercentage: Float
    $insuranceLimit: Float
    $insuranceUnlimited: Boolean
    $approvalRequired: Boolean
    $insuranceStartMonth: Int
    $priceList: ID
    $disabled: Boolean
    $forcePolicySelect: Boolean
    $nphiesCode: String
    $nphiesInsuranceCompanyId: String
    $tpaNphiesCode: String
    $taxNumber: String
    $street: String
    $additionalStreet: String
    $city: String
    $citySubdivision: String
    $building: String
    $postalZone: String
    $plotIdentification: String
    $countrySubEntity: String
    $countryCode: String
  ) {
    editInsuranceCompany(
      insuranceCompany: $insuranceCompany
      name: $name
      number: $number
      email: $email
      details: $details
      taxPercent: $taxPercent
      insuranceLimit: $insuranceLimit
      insurancePercentage: $insurancePercentage
      insuranceUnlimited: $insuranceUnlimited
      approvalRequired: $approvalRequired
      insuranceStartMonth: $insuranceStartMonth
      priceList: $priceList
      disabled: $disabled
      forcePolicySelect: $forcePolicySelect
      nphiesCode: $nphiesCode
      nphiesInsuranceCompanyId: $nphiesInsuranceCompanyId
      tpaNphiesCode: $tpaNphiesCode
      taxNumber: $taxNumber
      street: $street
      additionalStreet: $additionalStreet
      city: $city
      citySubdivision: $citySubdivision
      building: $building
      postalZone: $postalZone
      plotIdentification: $plotIdentification
      countrySubEntity: $countrySubEntity
      countryCode: $countryCode
    ) {
      id
      name
      number
      email
      details
      taxPercent
      taxNumber
      street
      additionalStreet
      city
      citySubdivision
      building
      postalZone
      plotIdentification
      countrySubEntity
      countryCode
      createdAt
      updatedAt
      insurancePercentage
      insuranceUnlimited
      insuranceLimit
      totalPolicies
      approvalRequired
      insuranceStartMonth
      forcePolicySelect
      disabled
      nphiesCode
      nphiesInsuranceCompanyId
      tpaNphiesCode
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      priceList {
        id
        name
      }
    }
  }
`

export default EDIT_INSURANCE_COMPANY
